<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Loading overlay -->
    <div v-if="loading" class="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
      <div class="text-center">
        <div class="spinner w-8 h-8 mx-auto mb-4"></div>
        <p class="text-gray-600">Loading Annzz...</p>
      </div>
    </div>

    <!-- Main app content -->
    <div v-else>
      <!-- Navigation - Only Logo -->
      <nav v-if="showNavigation" class="bg-white shadow-sm border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between items-center h-16">
            <!-- Logo -->
            <div class="flex items-center">
              <router-link to="/" class="flex items-center space-x-2">
                <div class="w-8 h-8">
                  <img 
                    src="/logo6.png" 
                    alt="Annzz Logo" 
                    class="w-full h-full object-contain"
                  />
                </div>
                <span class="text-xl font-semibold text-gray-900 font-luxury">Annzz</span>
              </router-link>
            </div>

            <!-- Empty space to maintain layout -->
            <div></div>
          </div>
        </div>
      </nav>

      <!-- Main content -->
      <main>
        <router-view />
      </main>

      <!-- Global Notification Manager -->
      <NotificationManager />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from './stores/user'
import NotificationManager from './components/NotificationManager.vue'

export default {
  name: 'App',
  components: {
    NotificationManager
  },
  setup() {
    const router = useRouter()
    const userStore = useUserStore()
    
    const loading = ref(true)
    
    // Computed properties
    const showNavigation = computed(() => {
      return !router.currentRoute.value.meta.hideNavigation
    })
    
    // Lifecycle
    onMounted(async () => {
      try {
        await userStore.initialize()
      } catch (error) {
        console.error('Failed to initialize app:', error)
      } finally {
        loading.value = false
      }
    })
    
    return {
      loading,
      showNavigation,
      userStore
    }
  }
}
</script>

<style scoped>
/* Additional app-specific styles */
</style> 